
import { getEditLocation } from "../../../core/util/functions";
export const dividendsLocation = "/reports/dividends";
export const getDividendsEditLocation = (id?: string) =>
 getEditLocation(dividendsLocation, undefined, id);

 export const editRouter = getDividendsEditLocation(":divId?");